import {ReportFilterBase} from './reportFilterBase';

export class ReportFilterByAnswer extends ReportFilterBase{

    answer:string;

}
